import articlePublicationStatuses from "astrid-firestore/src/api/articles/constants/articlePublicationStatuses";

import Label from "../../../ui/components/Label/Label";

import usePublicationStatuses from "../../hooks/usePublicationStatuses";

export default function ArticlePublicationStatus({ article }) {
	const publicationStatuses = usePublicationStatuses();
	const status = publicationStatuses[article?.publicationStatus || articlePublicationStatuses.NOT_PUBLISHED];
	return (
		<Label style={{ whiteSpace: "nowrap" }} color={status.color}>
			{status.text}
		</Label>
	);
}
